import script from "./Confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Confirm.vue?vue&type=script&lang=ts&setup=true"

import "./Confirm.vue?vue&type=style&index=0&id=188269c8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188269c8"]])

export default __exports__